import { FC, memo } from 'react';

import { MassMessageBuilding, MassMessageSpace } from 'models';

import BuildingGroup from './building-group';

import { useStyles } from './style';

interface SpacesSelectionListProps {
  buildings: MassMessageBuilding[];
  disabled?: boolean;
  selectedSpaces: MassMessageSpace[];
  onSelectSpaces?: (spaces: MassMessageSpace[], checked: boolean) => void;
}

const SpacesSelectionList: FC<SpacesSelectionListProps> = ({
  disabled = false,
  buildings,
  selectedSpaces,
  onSelectSpaces,
}) => {
  const classes = useStyles();

  return (
    <ul className={classes.ul}>
      {buildings.map((building) => (
        <BuildingGroup
          key={building.Id}
          building={building}
          disabled={disabled || !!!building.Spaces.length}
          selectedSpaces={selectedSpaces}
          onSelectSpaces={onSelectSpaces}
        />
      ))}
    </ul>
  );
};

export default memo(SpacesSelectionList);
